import React from 'react'
import { get } from 'lodash'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ProfileEditForm } from 'Containers/Form/Profile/ProfileEdit'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { updateUserById, getUserById } from 'Reducers/Users/actions'

import { authorization } from 'Module/Auth/Auth'
import { PATHS } from 'Config/Routing/paths'

const ProfileEdit = props => {
  const history = useHistory()
  const dispatch = useDispatch()

  const handleProfileEditFormSubmit = values => {
    const callbacks = {
      onSuccess: () => {
        dispatch(getUserById(userId))
        handleProfileEditEditFormSuccess()
      },
    }

    const payload = imageUrl => ({
      profile_picture: imageUrl,
      first_name: values.firstName,
      last_name: values.lastName,
    })

    const userId = authorization.getUser().id
    const imageFile = get(values, 'profilePicture[0]')
    if (imageFile.type) {
      dispatch(
        uploadProfileImage(userId, imageFile, {
          onSuccess: imageUrl => {
            dispatch(updateUserById(userId, payload(imageUrl), callbacks))
          },
        }),
      )
    } else {
      dispatch(updateUserById(userId, payload(), callbacks))
    }
  }

  const handleProfileEditEditFormSuccess = () => {
    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.profile}`)
  }

  return <ProfileEditForm onSubmit={handleProfileEditFormSubmit} />
}

export default ProfileEdit



// WEBPACK FOOTER //
// ./src/Containers/Profile/ProfileEdit/index.js